<script setup lang="ts">
import { Settings } from '@/lib/trashsim/settings';
import { computed } from 'vue';
import SimulateInput from './SimulateInput.vue';

const props = defineProps<{
    modelValue: Settings
}>()

const emits = defineEmits<{
    (e: 'update:modelValue', value: Settings): void
}>()

type opts = { type?: string, values?: Object | any[], suffix?: string}
const short: {[key: string]: opts} = {
    simulations: {},
    plunder: {type: 'select', values: [50, 75, 100], suffix: '%'},
    fleetWarSpeed: {},
    fleetHoldSpeed: {},
    fleetToDebris: {},
    defenseToDebris: {},
    numberOfGalaxies: {},
    deuteriumSaveFactor: {},
    cargoHyperspaceFactor: {},
    deuteriumInDebris: {type: 'checkbox'}
}

const settings = computed({
    get: () => props.modelValue,
    set: (value: Settings) => emits('update:modelValue', value)
})
</script>

<template>
    <div id="settings-column" class="inner-column">
        <div class="content">
            <h3 class="settings-title">{{ $t('home.settings.title') }}</h3>
            <ul class="simulate-values">
                <li class="clearfix" v-for="(opts, key) in short">
                    <SimulateInput
                        v-model="settings[key as keyof Settings]"
                        :label="$t(`home.settings.${key}`)"
                        :type="opts?.type"
                        :values="opts?.values"
                        :suffix="opts?.suffix"
                    />
                </li>
            </ul>
        </div>
    </div>
</template>